import React from 'react';
import { FloMenuButton, FloComponentProps } from 'components';
import styles from './LocationRolesActions.module.css';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { RoleType } from 'model';

interface LocationRolesActionsProps extends FloComponentProps {
  isSelectedAny: boolean;
  selectedNumber: number;
  isGrantFullAccessEnabled: boolean;
  isGrantLimitedAccessEnabled: boolean;
  isRevokeAccessEnabled: boolean;
  onActionClick: (role: RoleType | null) => void;
  onManageNotifications: () => void;
}

export const LocationRolesActions: React.FC<LocationRolesActionsProps> = React.memo(({
  className,
  isSelectedAny,
  selectedNumber,
  isGrantFullAccessEnabled,
  isGrantLimitedAccessEnabled,
  isRevokeAccessEnabled,
  onActionClick,
  onManageNotifications
}) => {
  const { t } = useTranslation();

  return (
    <div
      className = {classnames(className, styles.root)}
    >
      { isSelectedAny &&
        <>
          <FloMenuButton
            className   = "float-right"
            text        = {t('Actions')}
            name        = "actions-location-roles-btn"
            menuItems   = {[
              { id: 'grant-full-access', onClick: () => onActionClick('fullaccess'), title: t('Grant Full Access'), disabled: !isGrantFullAccessEnabled },
              { id: 'grant-limited-access', onClick: () => onActionClick('readonly'), title: t('Give Limited Access'), disabled: !isGrantLimitedAccessEnabled },
              { id: 'revoke-access', onClick: () => onActionClick(null), title: t('Revoke Access'), disabled: !isRevokeAccessEnabled },
              { id: 'manage-notifications', onClick: () => onManageNotifications(), title: t('set-alarm-preferences') },
            ]}
          />
          <span className = {classnames("float-right", styles.itemsSelected)} >{t('selected-items', { count: selectedNumber })}</span>
        </>
      }
    </div>
  )
})